// extracted by mini-css-extract-plugin
module.exports = {"card":"styles__card___2x6pe","form-container":"styles__form-container___3B4GB","label-title":"styles__label-title___1kfig","button":"styles__button___nbR6q"};